export enum Accent {
  Blue = 'blue',
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
  Mauve = 'mauve',
  Purple = 'purple',
}
